/* eslint-disable import/prefer-default-export */
/* eslint-disable multiline-ternary */
import styled from 'styled-components';

import Typography from '../Typography';

export const AssistiveText = styled(Typography)`
   position: absolute;
    top: 0;
    left: 0;
    padding: 0;
    margin: 0;
    clip: rect(1px, 1px, 1px, 1px);
`;
